import { _ as _extends } from '../../_rollupPluginBabelHelpers-c245b26a.js';
import { forwardRef } from 'react';
import useId from '@indeed/ihl-use-id';
import { FORM_SIZES } from '../../constants/index.js';
import { parseItems } from '../../utils/fields.js';
import { jsx } from '@emotion/react';
import { FormField } from '../FormField/FormField.js';
import { Select } from '../Select/Select.js';
import '@indeed/ifl-css';
import '@indeed/ifl-icons';
import '../../utils/createResponsive.js';
import '../Label/Label.js';
import '../../utils/styled.js';
import '../../utils/transition.js';
import '../../utils/warnDeprecation.js';
import '../../utils/warn.js';
import '../VisuallyHidden/VisuallyHidden.js';
import '../Text/Text.js';
import '../Box/Box.js';
import '../Flex/Flex.js';
import '@indeed/ifl-icons/ChevronDown';
import '../../utils/mergeRefs.js';
import '../../hooks/useHasFocus.js';
import '../IconWrapper/IconWrapper.js';

const SelectFormField = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    name,
    options = [],
    selectProps,
    selectRef,
    ...props
  } = _ref;
  const {
    disabled,
    invalid,
    size
  } = props;
  const defaultId = `ifl-SelectFormField-${useId()}`;
  const id = (selectProps == null ? void 0 : selectProps.id) || defaultId;
  const autoGeneratedHelperTextId = `ifl-SelectFormField-helperTextId-${useId()}`;
  const helperTextId = props.helperTextId || (props.helperText ? autoGeneratedHelperTextId : undefined);
  const autoGeneratedErrorTextId = `ifl-SelectFormField-errorTextId-${useId()}`;
  const errorTextId = props.errorTextId || (props.errorText ? autoGeneratedErrorTextId : undefined);
  const ariaDescribedby = ([helperTextId, errorTextId].filter(value => value !== undefined) || []).join(" ");
  const parsedOptions = parseItems(options);
  return jsx(FormField, _extends({
    ref: ref,
    helperTextId: helperTextId,
    errorTextId: errorTextId,
    htmlFor: id
  }, props), jsx(Select, _extends({
    id: id,
    ref: selectRef,
    name: name,
    disabled: disabled,
    invalid: invalid,
    "aria-describedby": ariaDescribedby || undefined,
    size: size
  }, selectProps), parsedOptions.map((optionProps, idx) => jsx("option", _extends({
    key: idx
  }, optionProps), optionProps.children || optionProps.label))));
});
const SELECT_FORM_FIELD_SIZES = FORM_SIZES;
SelectFormField.displayName = "SelectFormField";

export { SELECT_FORM_FIELD_SIZES, SelectFormField };
